<template>

    <div class="select">

      <button class="select__btn" @click.prevent="thumbClicked" :disabled="disabled" dusk="select-btn">

        {{selectedOption}}

        <i class="icon--md fas fa-angle-down"></i>

      </button>

      <select :id="selectId" v-model="selected" :disabled="disabled" name="select" @change="selectorChange" @blur="selectorChange" @input="selectorChange">

        <option value="0">{{emptytext}}</option>

        <template v-for="(value, key, index) in options" v-if="!selectByValue">

            <option :value="key">{{value}}</option>

        </template>

        <template v-for="(value, key, index) in options" v-if="selectByValue">

          <option :value="value">{{value}}</option>

        </template>

      </select>

      <transition name="fade-down">

        <div class="select__list" v-if="open" v-click-outside="closeSelector">

          <ul>

            <li v-for="(value, key, index) in options"><a href="#" @click.prevent="optionClicked(key, value)">{{value}}</a></li>

          </ul>

        </div>

      </transition>

    </div>

</template>

<script>
    export default {
        data: function () {
            return {
                open: false,
                selected: 0,
                selectId: '',
                doneOpening:false,
            }
        },
        computed: {
            selectedOption(){
                if(this.selected === 0 && this.useNull){
                    return this.emptytext;
                }else if(this.selected === undefined && this.useNull){
                    return this.emptytext;
              }

                if (this.selected !== null) {
                    if (this.options instanceof Object && !Array.isArray(this.options) && !this.selectByValue) {
                        let selected = Object.keys(this.options).filter((item, index) => {
                            return (item == this.selected);
                        });
                        if(Array.isArray(selected)){
                            selected = selected[0];
                        }
                        return this.options[selected];
                    } else {
                        if(this.selectByValue){
                            return String(this.selected);
                        }else{
                            return this.options[this.selected];
                        }
                    }
                }
                return this.emptytext;
            },

            isMobile(){
        /*        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

                // Windows Phone must come first because its UA also contains "Android"
                if (/windows phone/i.test(userAgent)) {
                    return true
                }

                if (/android/i.test(userAgent)) {
                    return true
                }

                // iOS detection from: http://stackoverflow.com/a/9039885/177710
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    return true
                }*/

                return false
            }
        },
        watch:{
            value(){
                if(this.value === null){
                  this.selected = null;
                }
                this.selected = this.value;
            },
            disabled(){
                this.open = false;
                this.selected = 0;
                this.$emit('input', 0);
            }
        },
        props: ['options', 'emptytext', 'value', 'selectByValue', 'disabled', 'left', 'useNull'],
        methods: {
            thumbClicked(){
                if(this.disabled){
                    return;
                }

                if (!this.isMobile) {
                    if(!this.open){
                        this.doneOpening = false;
                        setTimeout(()=>{
                            this.doneOpening = true;
                        }, 10);
                    }

                    return this.open = !this.open;

                }else{
                    return this.open = !this.open;
                }

                var element = document.getElementById(this.selectId);
                element.focus();
            },
            optionClicked(index, value){
                if(this.disabled){
                    return;
                }

                if(this.selectByValue){
                    this.selected = value;
                }else{
                    this.selected = index;
                }

                console.log('option clicked!');

                this.$emit('input', this.selected);
                this.$emit('change');
                this.$emit('blur');

                this.open = false;
            },
            makeRandomString(){
                var text = "";
                var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

                for (var i = 0; i < 5; i++)
                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                return text;
            },
            simulateMouseClickOn(element){
                if(this.disabled){
                    return;
                }

                var evt = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                    clientX: 20,
                  /* whatever properties you want to give it */
                });
                element.dispatchEvent(evt);
            },
            closeSelector(){
                if(this.open && this.doneOpening){
                    this.open = false;
                }
            },
            // Hack for Dusk tests
            selectorChange(){
                if (!this.isMobile && this.selectByValue){
                    this.optionClicked(null, this.selected);
                }
            },
        },
        created(){
            this.selectId = this.makeRandomString();
            if(this.value)
            {
                this.selected = this.value;
            }
            if(this.useNull && this.selected === 0){
                this.selected == null;
            }
        }
    }
</script>
